export class ChatAPI {
  private webhookUrl: string;
  private chatInputKey: string;
  private chatSessionKey: string;

  constructor(
    webhookUrl: string,
    chatInputKey = 'chatInput',
    chatSessionKey = 'sessionId'
  ) {
    this.webhookUrl = webhookUrl;
    this.chatInputKey = chatInputKey;
    this.chatSessionKey = chatSessionKey;
  }

  async sendMessage(message: string, sessionId: string, metadata?: Record<string, any>, action?: string): Promise<string> {
    try {
      const clkToken = localStorage.getItem('clk-token');
      const enrichedMetadata = {
        ...metadata,
        ...(clkToken && { 'clk-token': clkToken }),
      };

      const payload = {
        [this.chatInputKey]: message,
        [this.chatSessionKey]: sessionId,
        ...(action && { action }),
        ...(enrichedMetadata && { metadata: enrichedMetadata }),
      };

      const response = await fetch(this.webhookUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      let responseText = '';

      if (data.response && data.response.text) {
        responseText = data.response.text;
      } else if (typeof data === 'string') {
        responseText = data;
      } else if (data.text) {
        responseText = data.text;
      } else if (data.output) {
        responseText = data.output;
      } else if (data.message) {
        responseText = data.message;
      } else if (typeof data === 'object' && data !== null) {
        const possibleTextFields = ['content', 'result', 'answer', 'response'];
        for (const field of possibleTextFields) {
          if (data[field] && typeof data[field] === 'string') {
            responseText = data[field];
            break;
          }
        }
      } else {
        responseText = JSON.stringify(data);
      }

      return responseText.replace(/\\n/g, ' ').replace(/\n/g, ' ').replace(/\s+/g, ' ').trim();
    } catch (error) {
      console.error('Chat API error:', error);
      throw new Error('Failed to send message. Please try again.');
    }
  }

  async loadPreviousSession(sessionId: string): Promise<string> {
    return this.sendMessage('', sessionId, {}, 'loadPreviousSession');
  }

  async generateChatTitle(prompt: string): Promise<{ title: string }> {
    try {
      const response = await fetch('https://n8n.clickster.io/webhook/b3942b18-919a-4560-af57-87d8f1caec4f', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ prompt }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Title generation error:', error);
      throw new Error('Failed to generate chat title');
    }
  }

}
